import { render, staticRenderFns } from "./list.vue?vue&type=template&id=c79efa2e&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=c79efa2e&prod&scoped=true&lang=css"
import style1 from "./list.vue?vue&type=style&index=1&id=c79efa2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79efa2e",
  null
  
)

export default component.exports